export default /* @ngInject */ class UpgradeFlowCtrl {

    constructor($q, $mdDialog, signupDataStore, authData, authService, ProductsResource) {
        this.$q = $q;
        this.$mdDialog = $mdDialog;
        this.signupDataStore = signupDataStore;
        this.authData = authData;
        this.authService = authService;
        this.ProductsResource = ProductsResource;

        // Preload user data.
        this.userPromise = this.fetchUserData();
        this.userPromise.then((user) => {
            this.signupDataStore.account = user;
            this.signupDataStore.upgrade = {
                $mdDialog: this.$mdDialog,
                stage: 'chooseplan'
            };
        });
    }

    startUpgradeFlow() {
        this.userPromise.then(() => {
            this.signupDataStore.upgrade.stage = 'payment';
        });
    }

    fetchUserData() {
        let user;
        let deferred = this.$q.defer();
        this.authData().then((data) => {
            user = data;
            deferred.resolve(user);
        });

        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./user/upgrade/upgrade-flow-ctrl.js